import { toPersianChars, digitsFaToEn, digitsArToEn, digitsArToFa, digitsEnToFa } from "@persian-tools/persian-tools";

export const toPersian = (text) => {
	return text ? toPersianChars(digitsArToFa(digitsEnToFa((text)))) : text;
}
export const toEnglish = (text) => {
	return text ? digitsFaToEn(digitsArToEn(text)) : text;
}
export const charsNormalize = (text) => {
	return text ? toPersianChars(digitsFaToEn(digitsArToEn(text))) : text;
}
